module.exports = "<div class=\"left-arrow\">\n  <img *ngIf=\"!isFirstPage()\" (click)=\"prevPage()\" src=\"assets/btn-chevron-lt.svg\">\n</div>\n<div #paper class=\"paper\" (mousedown)=\"gestureStart($event)\" (touchstart)=\"swipe($event, 'start')\" (touchend)=\"swipe($event, 'end')\"></div>\n<div class=\"right-arrow\">\n  <img *ngIf=\"!isLastPage()\" (click)=\"nextPage()\" src=\"assets/btn-chevron-gt.svg\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cockehsu-catalog.component.html
// module id = ./src/app/cockehsu-catalog.component.html
// module chunks = main